/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PageInfoDto } from '../../models/page-info-dto';
import { ReviewDto } from '../../models/review-dto';

export interface ReviewAdminControllerSearchOffsetV1$Params {

/**
 * 페이지 크기
 */
  pageSize: number;

/**
 * 정렬 기준
 */
  orderBy?: string;

/**
 * 정렬 방향
 */
  align?: 'asc' | 'desc';

/**
 * 검색어
 */
  query?: string;

/**
 * 페이지 번호
 */
  pageNo: number;

/**
 * 노출 여부
 */
  isExposed?: boolean;
}

export function reviewAdminControllerSearchOffsetV1(http: HttpClient, rootUrl: string, params: ReviewAdminControllerSearchOffsetV1$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'items': Array<ReviewDto>;
'pageInfo': PageInfoDto;
}>> {
  const rb = new RequestBuilder(rootUrl, reviewAdminControllerSearchOffsetV1.PATH, 'get');
  if (params) {
    rb.query('pageSize', params.pageSize, {});
    rb.query('orderBy', params.orderBy, {});
    rb.query('align', params.align, {});
    rb.query('query', params.query, {});
    rb.query('pageNo', params.pageNo, {});
    rb.query('isExposed', params.isExposed, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      'items': Array<ReviewDto>;
      'pageInfo': PageInfoDto;
      }>;
    })
  );
}

reviewAdminControllerSearchOffsetV1.PATH = '/api/v1/reviews/admin/search/offset';
